export default {
  methods: {
    clearFields(obj) {
      for (let prop in obj) {
        obj[prop] = ''
      }
    },
  },
}
